import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc.module';
import { TermsPageRoutingModule } from './terms-routing.module';
import { TermsPageComponent } from './terms.page';

@NgModule({
  declarations: [TermsPageComponent],
  imports: [CommonModule, FormsModule, IonicModule, TermsPageRoutingModule, MiscModule]
})
export class TermsPageModule {}
